import { Component, HostListener, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { LangTextDirective } from './awasBandhu/directives/lang-text.directive';
import { CommonsService } from './awasBandhu/services/commonservices/commons.service';
import { LanguageService } from './awasBandhu/services/language.service';
import { SidebarService } from './awasBandhu/services/sidebar.service';
import Swal from 'sweetalert2';
import { decrypt, encrypt } from './awasBandhu/services/auth/crypto.util';
import { IdleService } from './awasBandhu/services/auth/idle.service';
import { AuthService } from './awasBandhu/services/auth/auth.service';
import { AuthenticationService } from './authentication.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule, RouterLink,
    RouterOutlet,
    LangTextDirective
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'my-app';
  currentLang: 'en' | 'hi' = 'hi';

  hideLayout = false;

  showMenuButton = false;
  isSidebarOpen = false;
  showProfile = false;

  districtSelected = false;
  districtName = '';
  districtLogo = '';

  profileName = '';
  designation = '';

  showUserName = false;

  isSessionPassword = false;


  constructor(
    private sidebarService: SidebarService,
    private router: Router,
    private languageService: LanguageService,
    public common: CommonsService, private idleService: IdleService, private authService: AuthService,
    private authenticationService: AuthenticationService

  ) {
    try {

      this.currentLang = this.languageService.currentLang;

      this.languageService.language$
        .subscribe(lang => {
          this.currentLang = lang;
        });

    } catch (Error) {
      console.log("Error while data parse", Error)
    }
    // sessionStorage.removeItem('user');
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;

        this.hideLayout = url === '/dashboards/sessionpassword' || url === '/login' || url === '/maintenance';

        this.isSessionPassword = url === '/dashboards/sessionpassword';

        const isMisReviewer = this.common.user?.u_type === 'MIS_REVIEWER';
        this.showUserName = url.startsWith('/dashboards') && !this.isSessionPassword && !isMisReviewer;
        this.showMenuButton = url.startsWith('/dashboards') && !this.isSessionPassword && !isMisReviewer;
        this.showProfile = (url.startsWith('/dashboards') && !this.isSessionPassword) || isMisReviewer;
        if (url === '/login') {
          this.authService.logout(true); // silent logout, no redirect
        }
      });

    // this.router.events
    //   .pipe(filter(event => event instanceof NavigationEnd))
    //   .subscribe((event: NavigationEnd) => {
    //     const url = (event as NavigationEnd).urlAfterRedirects;
    //     this.hideLayout = url === '/dashboards/sessionpassword' || url === '/login';

    //     this.showUserName = url.startsWith('/dashboards');

    //     this.showMenuButton = url.startsWith('/dashboards');
    //     this.showProfile = url.startsWith('/dashboards');

    //     if (url === '/districts' || url === '/login') {
    //       this.districtSelected = false;
    //       this.districtName = '';
    //       this.districtLogo = '';
    //     }

    //     this.isSidebarOpen = false;
    //     this.sidebarService.closeSidebar?.();
    //   });
  }

  @HostListener('window:beforeunload')
  saveToSession() {
    this.common.saveUserToStorage();
    // this.common.saveToken(...) not needed – we already saved it on login
  }

  // Optional – if you want to force reload on window:load (rarely needed)
  // @HostListener('window:load')
  // onWindowLoad() {
  //   this.common.loadUserFromStorage();
  //   this.common.loadToken();
  // }

  async ngOnInit() {
    const urlParams = new URLSearchParams(window.location.search);
    const urlCpatToken = urlParams.get('cpat');
    let isCpatLogin = false;
    let cpatJson: string = '';

    if (urlCpatToken) {
      const rawCpat = urlCpatToken;
      const urlDecoded = decodeURIComponent(rawCpat);
      try {
        cpatJson = atob(urlDecoded);
        isCpatLogin = true;
      } catch (e) {
        console.error('CPAT is not valid base64', e);
      }
    }

    if (isCpatLogin) {
      await this.sendTokenToBackend(JSON.parse(cpatJson));
      this.removeTokenFromUrl();
      return;
    }




    //  this.idleService.startWatching();


  }


  async sendTokenToBackend(token: any) {
    // this.tsppinner.show('', '');
    try {
      let resp = await this.authenticationService.sendCpatTokenToBackend(token);
      if (resp['error'] == false && resp['data']?.length > 0) {
        let userData: any[];
        try {
          userData = typeof resp['data'] === 'string' ? JSON.parse(resp['data']) : resp['data'];
        } catch (e) {
          userData = [];
        }
        const user = userData[0];
        if (user?.u_type === 'MIS_REVIEWER') {
          this.common.user = user;
          // Route to NF 68 report if project code is 2989, otherwise NF 32
          if (Number(user.projcode) === 2989) {
            this.router.navigate(['/dashboards/cm-review-report68']);
          } else {
            this.router.navigate(['/dashboards/cm-review-report']);
          }
          return;
        }
      } else {
        // this.tsppinner.hide();
        const errMsg = typeof resp['data'] === 'string' ? resp['data'] : 'DARPAN authentication failed';
        Swal.fire('Error', errMsg, 'error');
      }
    } catch (err: any) {
      // this.tsppinner.hide();
      console.error('[CPAT] sendTokenToBackend error:', err);
      let errorMsg = 'Unable to validate DARPAN token. Please try again.';
      if (err && err.error && err.error.data) {
        try {
          errorMsg = JSON.parse(err.error.data);
        } catch (e) {
          errorMsg = err.error.data;
        }
      }
      Swal.fire('Error', errorMsg, 'error');
    }
  }

  // setAuthTokenCookie(token: string) {
  //   sessionStorage.removeItem('1000');
  //   const isHttps = window.location.protocol === 'https:';
  //   const securePart = isHttps ? '; Secure' : '';
  //   document.cookie = `auth_token=${encodeURIComponent(token)}; Path=/; SameSite=Lax${securePart}`;
  // }


  removeTokenFromUrl() {
    window.history.replaceState({}, document.title, window.location.pathname);
  }




  async getserver() {
    var resp = await this.common.getserver();
    // if (resp['error'] ) {
    // 	this.router.navigate(['/error']);
    // }  
  }

  // switchLang(event: Event) {
  //   const target = event.target as HTMLSelectElement;
  //   const lang = target.value as 'en' | 'hi';
  //   this.languageService.setLanguage(lang);
  // }
  switchLang(event: Event) {
    const target = event.target as HTMLSelectElement;
    const selectedLang = target.value as 'en' | 'hi';
    const previousLang = this.currentLang;

    // If same language selected, do nothing
    if (selectedLang === previousLang) {
      return;
    }

    const isHindi = previousLang === 'hi';

    Swal.fire({
      title: isHindi ? 'भाषा बदलें?' : 'Change Language?',
      text: isHindi
        ? 'यदि आप भाषा बदलते हैं, तो आपके द्वारा भरा गया डेटा बदल या हट सकता है।'
        : 'If you change the language, the data filled by you may be changed or lost.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: isHindi ? 'हाँ, बदलें' : 'Yes, change',
      cancelButtonText: isHindi ? 'नहीं, रहने दें' : 'No, keep current',
      reverseButtons: true,
      allowOutsideClick: false
    }).then(result => {
      if (result.isConfirmed) {
        this.languageService.setLanguage(selectedLang);

        setTimeout(() => {
          window.location.reload();
        }, 0);
      } else {
        target.value = previousLang;
      }
    });
  }
  // logout() {
  //   sessionStorage.removeItem('user');
  //   this.router.navigate(['/login']);
  // }
  logout() {
    this.authService.logout();
  }
  // logout() {
  //   this.common.clearStorage();
  //   sessionStorage.clear();   // 🔥 CLEAR EVERYTHING
  //   this.common.user = null;  // reset memory
  //   this.router.navigate(['/login']);
  // }
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
    this.sidebarService.toggleSidebar();
  }
}
